import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profile: {},
};

const ProfileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfile(state, action) {
      state.profile = { ...state.profile, ...action.payload };
    },
    clearProfile(state) {
      state.profile = {};
    },
  },
});

export const { setProfile, clearProfile } = ProfileSlice.actions;
export default ProfileSlice.reducer;
